import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import GlobalStyle from 'utils/theme/globalStyles';
import hideElements from 'configs/hideElements';
import Header from 'modules/shared/common/components/Header';
import Sidebar from 'modules/shared/common/components/Sidebar';

import { MainWrapper, SidebarWrapper, ContentWrapper, PageWrapper } from './MainContainer.style';
import { sidebarItems } from '../../enums';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MainContainer = ({ children }) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);
  const loginInfo = useSelector(state => state.accountManagement.loginInfo);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const shouldShowHeader = hideElements.contextsThatHideHeader.includes(context) === false;
  const shouldShowSidebar = hideElements.contextsThatHideSidebar.includes(context) === false;

  return (
    <>
      <GlobalStyle />
      <MainWrapper>
        {shouldShowSidebar && (
          <SidebarWrapper>
            <Sidebar sidebarItems={sidebarItems} />
          </SidebarWrapper>
        )}
        <ContentWrapper>
          {shouldShowHeader && <Header loginInfo={loginInfo} />}
          <PageWrapper>{children}</PageWrapper>
        </ContentWrapper>
      </MainWrapper>
    </>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MainContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

MainContainer.defaultProps = {};

export default MainContainer;
